import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetRoomData, IGetRoomVars } from '../types';

export const GET_ROOM: TypedDocumentNode<IGetRoomData, IGetRoomVars> = gql`
  query getRoom($input: ReadRoomInput!) {
    readRoom(input: $input) {
      id
      capacity
      created
      groupTypes
      joinCode
      status
      staff {
        active
        confirmed
        email
        firstName
        id
        lastName
        phone
        role
        welcomed
      }
      startPin
      students {
        absent
        adultTestTakerFlag
        candDOB
        candFirstName
        candGender
        candLastName
        candMidInit
        candRegNo
        checkedInCenter
        checkedInRoom
        checkedInRoomTimestamp
        dapExamStatus {
          name
          timestamp
        }
        dapTestStatus {
          name
          payload {
            ... on DAPSectionStartTime {
              sectionName
            }
          }
          timestamp
        }
        deniedEntry
        displayedRegNo
        estimatedExamEndTime
        examStartTime
        grade8OrLowerFlag
        groupType
        id
        joinCode
        joinCodeTimestamp
        multiDayInd
        photoRequiredFlag
        room {
          id
          groupTypes
          title
        }
        roomIdTimestamp
        accommodationsArray {
          code
          supplementalInfo
        }
        startPin
        startPinTimestamp
        testPackageCount
        testPackageSeq
        updated
        waitListFlag
        asmtSubtypeCd
      }
      title
      updated
    }
  }
`;
